module.exports = new __parcel__URL__("dark.6d30a270.svg").toString();